import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Authenticated from '@/Layouts/Authenticated';
import IssueCard from '@/Components/IssueCard';

export default function Publication({ app, auth, pub, size }) {
    const [issues, setIssues] = useState([])
    const [next, setNext] = useState(null)

    const issueLink = (issue) => !pub.paid || auth.abilities.includes('read-epaper') ? issue.link : route('subscription')

    const loadIssues = async (api) => {
        const res = await axios.get(api)
        setIssues([...issues, ...res.data.issues])
        setNext(res.data.next)
    }
    const loadMore = async (event) => {
        event.preventDefault()
        await loadIssues(next)
    }

    useEffect(async () => {
        await loadIssues(route('epaper.issues', { code: pub.code, size: size }))
    }, [])

    return (
        <Authenticated app={app} auth={auth}>
            <div className="category-title">
                <div className="container">
                    <h1>{pub.name}</h1>
                </div>
            </div>

            <div className="content-wrapper">
                <div className="container">
                    <section className="section-cards">
                        <div className="row gy-5">
                            {issues && issues.map(issue => (
                                <IssueCard key={issue.date} name={issue.name} image={issue.thumbnail} link={issueLink(issue)} />
                            ))}

                            {next && (
                                <div className="col-12">
                                    <div className="btn-row">
                                        <a href="#" className="btn more" onClick={loadMore}>更多 <i className="icon-down-arrow"></i></a>
                                    </div>
                                </div>
                            )}
                        </div>
                    </section>
                </div>
            </div>

        </Authenticated>
    );
}
